import { makeStyles } from '@mui/styles'
import { Opacity } from '@mui/icons-material'

export const useStyles = makeStyles((theme) => ({//Estílos solamente del componente "LoginComponent"  
  title: {
    fontWeight: 600,
    // fontSize: 24,
    marginTop: theme.spacing(1),
    color:  theme.palette.primary.color,
    opacity: 1,
    width: '100% !important',
    textAligment: 'left',
  },
  subTitle: {
    // fontSize: 18,
    // marginTop: theme.spacing(2),
    marginTop: theme.spacing(1),
    textAlign: 'left',
    letterSpacing: 0,
    color:  theme.palette.primary.color,
    opacity: 1,
    width: '100% !important',
  },
  continueBtn: {
    alignSelf: 'center',
  },
  continueBtnDisabled: {
    alignSelf: 'center',
    cursor: 'not-allowed !important',
    pointerEvents: 'none !important'
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
}))
